<script setup lang="ts">
const props = defineProps<{
  label?: string;
}>();
</script>

<template>
  <div v-if="props.label" class="article-content__text article-content__text--prominent">
    {{ props.label }}
  </div>
  <div v-bind="$attrs" class="article-content__text">
    <slot />
  </div>
  <div class="article-content__spacer"></div>
</template>
